var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Navbar'),_c('div',{staticClass:"row default-layout",attrs:{"id":"content"}},[_c('div',{staticClass:"col"},[_vm._t("default")],2)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }